import { render, staticRenderFns } from "./Md200073Alert.vue?vue&type=template&id=f55e91c4&"
import script from "./Md200073Alert.vue?vue&type=script&lang=js&"
export * from "./Md200073Alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports